import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana59Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_25441)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("30"))}
        d="M656.18 635.729L672.566 629.175L646.348 573.462L607.021 565.269L593.912 620.981L656.18 635.729Z"
        fill={getFillByLot(30, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M598.835 506.276L638.162 516.108L661.103 566.905L646.355 573.46L585.727 560.351L598.835 506.276Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M539.841 491.529L598.831 506.277L585.723 560.351L525.094 545.604L539.841 491.529Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("31"))}
        d="M534.926 607.87L593.916 620.979L607.025 565.266L549.673 552.157L534.926 607.87Z"
        fill={getFillByLot(31, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("32"))}
        d="M477.58 591.486L534.932 607.873L549.679 552.16L493.966 537.412L477.58 591.486Z"
        fill={getFillByLot(32, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M482.492 475.145L539.843 491.531L525.096 545.605L467.744 530.857L482.492 475.145Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M425.134 458.758L482.486 475.144L467.738 530.857L407.109 512.832L425.134 458.758Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M367.792 442.375L425.144 458.761L407.119 512.835L349.768 493.172L367.792 442.375Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("33"))}
        d="M421.867 575.102L477.58 591.488L493.966 537.414L438.253 522.666L421.867 575.102Z"
        fill={getFillByLot(33, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("34"))}
        d="M364.502 557.076L421.854 575.101L438.24 522.665L382.527 504.641L364.502 557.076Z"
        fill={getFillByLot(34, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("35"))}
        d="M308.789 539.049L364.502 557.074L382.527 504.638L328.452 486.613L308.789 539.049Z"
        fill={getFillByLot(35, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M321.903 427.625L367.784 442.373L349.759 493.17L284.215 470.229L321.903 427.625Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("36"))}
        d="M257.997 521.028L308.794 539.052L328.459 486.617L284.216 470.23L254.72 503.003C250.787 513.49 255.266 519.389 257.997 521.028Z"
        fill={getFillByLot(36, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_25441"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_25441"
            transform="matrix(0.00224763 0 0 0.00297976 -3.2055 -2.08947)"
          />
        </pattern>
        <image
          id="image0_1466_25441"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
